import Tag from '@rio-cloud/rio-uikit/Tag';
import TagList from '@rio-cloud/rio-uikit/TagList';
import { FormattedMessage } from 'react-intl';
import { ALLOWED_PHONE_PREFIXES } from '../../../../validation/allowedPhonePrefixes';

function onlyUnique(value: string, index: number, array: string[]) {
    return array.indexOf(value) === index;
}

export const SupportedPhoneCountryCodes = () => {
    const countryCodes = ALLOWED_PHONE_PREFIXES.filter(onlyUnique).sort((left, right) => left.localeCompare(right));

    return (
        <div data-testid={'SupportedPhoneCountryCodes'}>
            <h4 className='margin-bottom-10'>
                <FormattedMessage id={'intl-msg:infoDialog.features.supportedPhoneCountryCodes.title'} />
            </h4>
            <div className='panel panel-default margin-bottom-0'>
                <div className='panel-body'>
                    <div className='display-flex justify-content-between align-items-center gap-10 flex-wrap margin-bottom-15'>
                        <div className='text-color-dark'>
                            <FormattedMessage id={'intl-msg:infoDialog.features.supportedPhoneCountryCodes.bodyText'} />
                        </div>
                    </div>
                    <TagList className='width-100pct' tagsPerRow={4}>
                        {countryCodes.map(countryCode => (
                            <Tag key={countryCode} muted round={false}>
                                <span className='display-flex justify-content-center text-medium'>{countryCode}</span>
                            </Tag>
                        ))}
                    </TagList>
                </div>
            </div>
        </div>
    );
};
